import { AuthApi } from './auth.api';
import { ConfigApi } from './config.api';
import { CoursesApi } from './courses.api';
import { DesktopsApi } from './desktops.api';
import { UsersApi } from './users.api';

export { AuthApi } from './auth.api';
export { ConfigApi } from './config.api';
export { CoursesApi } from './courses.api';
export { DesktopsApi } from './desktops.api';
export { UsersApi } from './users.api';
export type { Result } from '@libs/models';
export { ResultFactory } from '@libs/models';

export const authApi = new AuthApi();
export const coursesApi = new CoursesApi();
export const desktopsApi = new DesktopsApi();
export const usersApi = new UsersApi();
export const configApi = new ConfigApi();

export type DesktopModel = {
  id: string;
  name: string;
  status: string;
  [key: string]: any;
};

export type ParticipantModel = {
  id: string;
  avatarColor: string;
  displayName: string;
  avatarUrl?: string;
  avatar?: string;
  desktop?: DesktopModel;
};

export type UserBaseModel = {
  id: string;
  displayName: string;
  avatar?: string;
  avatarColor?: string;
};

export type FormsDefaultValuesSettings = {
  freshStartForm: FormsDefaultValuesSettingsFreshStartForm;
  [key: string]: any;
};

export type FormsDefaultValuesSettingsFreshStartForm = {
  [key: string]: any;
};

export type SentrySettings = {
  dsn: string;
  environment: string;
  [key: string]: any;
};

export type GoogleSettings = {
  clientId: string;
  [key: string]: any;
};

export type TimezoneModel = {
  id: string;
  label: string;
};

export type SelectItem = {
  label: string;
  value: string | number;
};
